import {
    Injectable
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackbarComponent } from 'projects/ui-library/src/lib/components/snackbar/snackbar.component';
import { ConfirmComponent } from 'ui-library';


@Injectable({
    providedIn: 'root'
})

export class Pop {
    lastAlert: any = {};
    timeoutAlert: any;
    alertPaused: boolean = false;
    fullscreenModal: any;

    constructor(
        private toastCtrl: MatSnackBar,
        private dialog: MatDialog,
    ) { }

    async toast(message: string, color: string = 'danger', duration = 4000, icon?: string) {
        if (color == "success")
            color = "primary";

        this.toastCtrl.openFromComponent(SnackbarComponent, {
            data: { message, icon },
            duration,
            panelClass: [color + '-toast']
        });
    }

    async success(message: string, color: string = 'primary', icon: string = 'check') {
        this.toast(message, color, 4000, icon);
    }

    async info(message: string, color: string = 'secondary', icon: string = 'info') {
        this.toast(message, color, 4000, icon);
    }

    async warning(message: string, color: string = 'warning', icon: string = 'warning') {
        this.toast(message, color, 4000, icon);
    }

    async error(message: string, color: string = 'danger', icon: string = 'error') {
        this.toast(message, color, 4000, icon);
    }

    async confirm(header: string, cb: any, validText: string = 'form.submit', cancelText: string = 'form.cancel') {
        const dialogRef = this.dialog.open(ConfirmComponent, {
            width: '500px',
            data: { title: header, ok: false, okText: validText, cancelText }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) cb(result);
        });
    }
}